import React, { useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
    ChartBarIcon,
    XMarkIcon,
    GlobeAltIcon,
    BriefcaseIcon,
    LightBulbIcon,
    ChartPieIcon,
    ChatBubbleLeftRightIcon,
    UserGroupIcon,
    MapPinIcon,
    NewspaperIcon,
    EnvelopeIcon,
    StarIcon,
    // PhoneIcon,
    CreditCardIcon
} from "@heroicons/react/24/outline";
import menuIcon from "../../assets/icons/menu.gif";
import logoIcon from "../../assets/logo/logo.svg";
import logoutIcon from "../../assets/icons/logout.gif";

export default function UserProfile() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        toast.success(t("Logged out successfully"), {
            position: "top-right",
            autoClose: 3000,
        });
        navigate("/login");
    };

    const toggleSidebar = () => {
        setIsSidebarOpen((prev) => !prev);
    };

    const sidebarLinks = [
        { path: "dashboard", label: t("Dashboard"), icon: ChartBarIcon },
        { path: "countries", label: t("Countries"), icon: GlobeAltIcon },
        { path: "projects", label: t("Projects"), icon: BriefcaseIcon },
        { path: "project-consulting", label: t("Project Consulting"), icon: LightBulbIcon },
        { path: "statistics", label: t("Statistics"), icon: ChartPieIcon },
        { path: "consultations", label: t("Consultations"), icon: ChatBubbleLeftRightIcon },
        { path: "partners", label: t("Partners"), icon: UserGroupIcon },
        { path: "locations", label: t("Locations"), icon: MapPinIcon },
        { path: "blog", label: t("Blog"), icon: NewspaperIcon },
        { path: "inbox", label: t("Inbox"), icon: EnvelopeIcon },
        { path: "customer-reviews", label: t("Customer Reviews"), icon: StarIcon },
        // { path: "contact-information", label: t("Contact Information"), icon: PhoneIcon },
        { path: "subscriptions", label: t("Subscriptions"), icon: CreditCardIcon },
    ];

    return (
        <div className="flex min-h-screen">
            {/* Sidebar */}
            <aside
                className={`fixed top-0 left-0 w-64 h-full bg-white shadow-lg border-r border-gray-200 transform transition-transform duration-300 ease-in-out z-[200] overflow-auto scrollbar-hidden ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"
                    }`}
            >
                <div className="p-6 flex justify-center items-center bg-[#0B2C3D]">
                    <div>
                        <img
                            src={logoIcon}
                            alt="Logo"
                            className="w-[135px]"
                            onError={(e) => (e.target.src = "https://via.placeholder.com/40")}
                        />
                    </div>
                    <button onClick={toggleSidebar} className="md:hidden text-white">
                        <XMarkIcon className="w-6 h-6" />
                    </button>
                </div>
                <nav className="h-[90%] flex flex-col justify-between gap-2 p-4">
                    <div className="flex flex-col gap-2">
                        {sidebarLinks.map((link) => {
                            const Icon = link.icon;
                            return (
                                <Link
                                    key={link.path}
                                    to={`/profile/${link.path}`}
                                    className="flex items-center gap-3 py-3 px-4 rounded-lg text-[#0B2C3D] hover:bg-[#0B2C3D] hover:text-white transition-colors duration-300"
                                    onClick={() => setIsSidebarOpen(false)}
                                >
                                    <Icon className="w-5 h-5" />
                                    <span className="font-semibold">{link.label}</span>
                                </Link>
                            );
                        })}
                    </div>
                </nav>
            </aside>

            {/* Main Content */}
            <div className={`flex-1 transition-all duration-300 ${isSidebarOpen ? "md:ml-64" : ""}`}>
                {/* Custom Header */}
                <header className="bg-white shadow-md py-4 px-6 flex justify-between items-center">
                    <div className="flex items-center gap-4">
                        <button onClick={toggleSidebar} className="text-[#0B2C3D]">
                            <img src={menuIcon} alt="Menu" className="w-[50px] h-[50px]" />
                        </button>
                    </div>
                    <div className="flex items-center gap-[5px]">
                        <button
                            onClick={handleLogout}
                            className="text-white transition-colors duration-300"
                        >
                            <img className="w-10 h-10" src={logoutIcon} alt="Logout" />
                        </button>
                    </div>
                </header>

                {/* Page Content */}
                <main className="p-8">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}